import { IndicatorType } from '../constants/common'
import AverageTrueRange from '../helpers/atr'
import { drawInVisibleArea } from '../utils/draw_in_visible_area'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class ATR extends Indicator<Attrs> {
  static type = IndicatorType.Atr
  static label = 'Average True Range'

  atr: number[] = []
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.atr = []
      const atr = new AverageTrueRange(this.period)
      for (let i = 0; i < this.data.close.length; i++) {
        atr.add(this.data.high[i], this.data.low[i], this.data.close[i - 1])
        this.atr[i] = atr.value
      }

      this.lastValue = this.atr.last() ?? null
    }
    const { min, max } = this.atr.length > 0 ? this.computeVisibleMinMax(this.atr) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    context.set('strokeStyle', this.getChartLayoutSettings().IndicatorSettings.general.Colors.line)
    context.translate(0.5, 0.5)
    context.beginPath()
    drawInVisibleArea(this.data.close, 0, this.fx, this.leftOffset, this.width, (i: number, x: number) => {
      context.lineTo(x, Math.round(this.fy(this.atr[i])))
    })
    context.stroke()
    context.translate(-0.5, -0.5)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 14,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `ATR ${this.period}`
  }
}

export default ATR
